import { render, staticRenderFns } from "./lectures.vue?vue&type=template&id=074679dc&"
import script from "./lectures.vue?vue&type=script&lang=js&"
export * from "./lectures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports